<template>
  <div class="intro p-3">
    <div id="wiki-introduction" style="display:none">
      <div class="loading" v-if="loading">
        <img src="../../assets/images/gif-loading.gif" alt="loading">
      </div>
      <p v-if="intro.length != 0">
        {{ intro }}
        <br /><br />
        資料來源：<a class="wiki-link" :href="link" target="_blank">維基百科</a>
      </p>
    </div>
    <div class="categ-blocks row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 mt-lg-5 mt-sm-4">
        <div v-for="(categ, index) in categs"
          :key="categ.title"
          v-if="index !== 0"
          class="col mb-5"
          @click="$emit('changeTab', categ.title)">
          <div class="card border-0 categ-block">
            <div class="row no-gutters">
              <div class="col-sm-4 col-md-3">
                <img v-bind:src="tabImages[categ.id]" class="card-img"><p>{{ categ.title }}</p>
              </div>
              <div class="col-sm-8 col-md-9">
                <div class="categ-content">
                  <p class="card-title orange" v-if="ordinaryDisplay[categ.id]">{{ categ.topstats[0].title }}</p>
                  <p class="card-text orange" v-if="noTownValue[categ.id]">（{{ thisCountyname }}之）</p>
                  <p class="card-text orange" v-if="noTownValue[categ.id]">{{ categ.topstats[0].title }}</p>
                  <p class="card-text h2 orange" :title=topStatsValueKSep[index]>{{ topStatsValueKSep[index] }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  // 'value' is v-model 'currentTab' sent from parent component
  props: ["categs", "location", "tabImages"],
  mounted() {
    this.waitlocation();
  },
  data() {
    return {
      intro: "",
      link: "",
      loading: false,
      topStatsValue: [],
      ordinaryDisplay: [],
      topStatsValueKSep: [],
      noTownValue: [],
      thisCountyname: "",
    };
  },
  methods: {
    waitlocation() {
      if (!this.location) {
        setTimeout(this.waitlocation, 50);
      } else {
        $(window).scrollTop(0);
        this.categs.forEach((categ, index) => {
          if (categ.id != "nullcat1") {
            this.thisCountyname = this.getThisCountyname();
            this.getTopStats(categ.id, index, this.getIndexCompare(categ));
          }
        });
      }
    },
    //getLocationIntro() {
    //  if (!this.location) {
    //    return;
    //  }
    //  this.loading = true;
    //  if (this.location.type == "county") {
    //    this.axios
    //      .post("dbpediacounty", {
    //        county_id_n: this.location.id,
    //      })
    //      .then((resp) => {
    //        //this.intro = resp.data.abstract
    //        this.intro = "";
    //        this.link = resp.data.link;
    //        this.loading = false;
    //      })
    //      .catch((err) => {
    //        console.log(err);
    //      });
    //  } else {
    //    this.axios
    //      .post("dbpediacursor", {
    //        town_id_n: this.location.id,
    //      })
    //      .then((resp) => {
    //        //this.intro = resp.data.abstract
    //        this.intro = "";
    //        this.link = resp.data.link;
    //        this.loading = false;
    //      })
    //      .catch((err) => {
    //        console.log(err);
    //      });
    //  }
    //},

    getIndexCompare(categ) {
      return categ.topstats.map((x) => {
        x.dataset = categ.subcategs.filter(
          (y) => y.id == x.subcateg
        )[0].table_prefix;
        x.minscl = categ.subcategs.filter((y) => y.id == x.subcateg)[0].minscl;
        return x;
      })[0];
    },

    getTopStats(categid, index, indexCompare) {
      //console.log(indexCompare);
      //console.log(this.location);
      var topStatsNull = false;
      if (indexCompare.minscl != "county") {
        this.axios
          .post("nationalrank", {
            dataset: indexCompare.dataset,
            year: "_" + indexCompare.year,
            adminscl: "_" + this.location.type,
            column: indexCompare.column,
            id: this.location.id,
          })
          .then((resp) => {
            this.noTownValue[categid] = false;
            this.ordinaryDisplay[categid] = true;
            if (resp.data[indexCompare.column] != null) {
              //console.log(resp.data[indexCompare.column])
              //console.log(this.noTownValue[categid])
              //console.log(this.ordinaryDisplay[categid])
              this.topStatsValue[index] = resp.data[indexCompare.column];
              this.$set(
                this.topStatsValueKSep,
                index,
                this.KSep(this.topStatsValue[index])
              );
            } else {
              this.axios
                .post("nationalrank", {
                  dataset: indexCompare.dataset,
                  year: "_" + indexCompare.year,
                  adminscl: "_county",
                  column: indexCompare.column,
                  id: this.location.countyid,
                })
                .then((resp) => {
                  if (resp.data[indexCompare.column] != null) {
                    this.topStatsValue[index] = resp.data[indexCompare.column];
                    this.$set(
                      this.topStatsValueKSep,
                      index,
                      this.KSep(this.topStatsValue[index])
                    );
                  } else {
                    this.$set(this.topStatsValueKSep, index, "－");
                  }
                })
                .catch(function(error) {
                  console.log(error);
                });
              topStatsNull = true;
            }
            this.ordinaryDisplay[categid] = this.testOrdinaryDisplay(
              topStatsNull,
              indexCompare
            );
            this.noTownValue[categid] = this.testNoTownValue(
              topStatsNull,
              indexCompare
            );
            //console.log(categid,this.ordinaryDisplay[categid],this.noTownValue[categid])
          })
          .catch(function(error) {
            console.log(
              indexCompare.dataset,
              indexCompare.year,
              this.location.type,
              indexCompare.column,
              this.location.id
            );
            console.log(error);
          });
      } else {
        this.axios
          .post("nationalrank", {
            dataset: indexCompare.dataset,
            year: "_" + indexCompare.year,
            adminscl: "_county",
            column: indexCompare.column,
            id: this.location.countyid,
          })
          .then((resp) => {
            this.noTownValue[categid] = false;
            this.ordinaryDisplay[categid] = true;
            if (resp.data[indexCompare.column] != null) {
              this.topStatsValue[index] = resp.data[indexCompare.column];
              this.$set(
                this.topStatsValueKSep,
                index,
                this.KSep(resp.data[indexCompare.column])
              );
            } else {
              this.$set(this.topStatsValueKSep, index, "－");
            }
            this.ordinaryDisplay[categid] = this.testOrdinaryDisplay(
              topStatsNull,
              indexCompare.minscl
            );
            this.noTownValue[categid] = this.testNoTownValue(
              topStatsNull,
              indexCompare.minscl
            );
            //console.log(categid,this.ordinaryDisplay[categid],this.noTownValue[categid])
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    testOrdinaryDisplay(topStatsNull, minscl) {
      return (
        (minscl != "county" && !topStatsNull) || this.location.type == "county"
      );
    },
    testNoTownValue(topStatsNull, minscl) {
      return (
        (minscl == "county" && this.location.type != "county") || topStatsNull
      );
    },
    KSep(val) {
      if (val != null) {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "－";
      }
    },
    getThisCountyname: function() {
      if (this.location) {
        return this.location.countyname;
      } else {
        return "";
      }
    },
  },
  watch: {
    location: {
      handler: function() {
        //this.getLocationIntro();
        this.categs.forEach((categ, index) => {
          if (categ.id != "nullcat1") {
            this.thisCountyname = this.getThisCountyname();
            if (this.thisCountyname) {
              this.getTopStats(categ.id, index, this.getIndexCompare(categ));
            }
          }
        });
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/custom_var";

.intro {
  padding: 0 50px;
}

#wiki-introduction {
  padding: 10px;
  display: flex;
  background: #fcf7ee;
}
.icon {
  margin-top: 17px;
}

.loading {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  img {
    width: 100px;
    height: 100px;
  }
}

.categ-blocks {
  .categ-block {
    cursor: pointer;
    background-color: #fffef8;
    .categ-title {
      width: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .categ-small {
      font-size: 15px;
    }
    .categ-value {
      font-size: 38px;
    }
    .orange {
      color: $ts-orange;
    }
  }
  .categ-block:hover {
    background: #fcf7ee;
    .orange {
      color: $ts-orange-btn-hover;
    }
  }
}

img {
  width: 50px;
  height: 50px;
}

.wiki-link {
  color: $ts-blue;
}
</style>
